import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareShowAllAssetVersionsMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  showAllAssetVersions?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UpdateShareShowAllAssetVersionsMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, showAllAssetVersions: boolean } | { __typename?: 'CollectionShare', id: string, showAllAssetVersions: boolean } | null } | null };


export const UpdateShareShowAllAssetVersions = /*#__PURE__*/ gql`
    mutation UpdateShareShowAllAssetVersions($shareId: ID!, $showAllAssetVersions: Boolean) {
  updateShare(
    input: {shareId: $shareId, settings: {showAllAssetVersions: $showAllAssetVersions}}
  ) {
    share {
      id
      showAllAssetVersions
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareShowAllAssetVersionsMutation, UpdateShareShowAllAssetVersionsMutationVariables>;

          

          export const useUpdateShareShowAllAssetVersionsMutation = (options?:MutationHookOptions<UpdateShareShowAllAssetVersionsMutation, UpdateShareShowAllAssetVersionsMutationVariables>) => useMutation(UpdateShareShowAllAssetVersions, options);
          

          export type UpdateShareShowAllAssetVersionsMutationOptions = MutationHookOptions<UpdateShareShowAllAssetVersionsMutation, UpdateShareShowAllAssetVersionsMutationVariables>;

          

          export type UpdateShareShowAllAssetVersionsMutationResult = ReturnType<typeof useUpdateShareShowAllAssetVersionsMutation>[1];

          
